import { render, staticRenderFns } from "./properties-component-button.vue?vue&type=template&id=5682af90&scoped=true"
import script from "./properties-component-button.vue?vue&type=script&lang=js"
export * from "./properties-component-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682af90",
  null
  
)

export default component.exports